import * as api from "Api";
import * as actions from "Actions";

export const fetchTaskCategorySuggestions = searchWord => {
  return (dispatch, getState) => {
    const { id } = getState().auth.currentOrganization;
    return dispatch(
      actions.setTaskCategorySuggestions(api.getTaskCategory(searchWord, id))
    );
  };
};

export const fetchClientGroupSuggestions = searchWord => {
  return (dispatch, getState) => {
    const { id } = getState().auth.currentOrganization;
    return dispatch(
      actions.setClientGroupSuggestions(api.getClientGroup(searchWord, id))
    );
  };
};

export const fetchClientSuggestions = (
  searchWord,
  typeClients = "",
  year = new Date().getFullYear()
) => {
  return (dispatch, getState) => {
    const { id } = getState().auth.currentOrganization;
    const groups = getState().timeSheetTree.filter.clientGroup.selected.map(
      ({ value }) => value
    );
    return dispatch(
      actions.setClientSuggestions(
        api.getClient(searchWord, groups, id, typeClients, year)
      )
    );
  };
};

export const fetchCollaboratorSuggestions = (
  searchWord,
  zones = [],
  squads = [],
  years = []
) => {
  return (dispatch, getState) => {
    const { id } = getState().auth.currentOrganization;

    return dispatch(
      actions.setCollaboratorsSuggestions(
        api.getCollaborators(searchWord, id, zones, squads, years)
      )
    );
  };
};

export const fetchZoneSuggestions = searchWord => {
  return (dispatch, getState) => {
    const { id } = getState().auth.currentOrganization;
    return dispatch(actions.setZonesSuggestions(api.getZone(searchWord, id)));
  };
};

export const fetchBusinessUnitSuggestions = searchWord => {
  return (dispatch, getState) => {
    const { id } = getState().auth.currentOrganization;
    return dispatch(
      actions.setBusinessUnitSuggestions(api.getBusinessUnit(searchWord, id))
    );
  };
};

export const fetchSquadsSuggestions = searchWord => {
  return (dispatch, getState) => {
    const { id } = getState().auth.currentOrganization;
    return dispatch(
      actions.fetchSquadsSuggestions(api.getSquads(searchWord, id))
    );
  };
};

export const fetchClusterSuggestions = searchWord => {
  return (dispatch, getState) => {
    const { id } = getState().auth.currentOrganization;
    return dispatch(
      actions.fetchClusterSuggestions(api.getClusters(searchWord, id))
    );
  };
};



// WEBPACK FOOTER //
// ./src/actions/thunks/filter.js